import React from "react";
import { Pie } from '@ant-design/charts';

export const Graph1 = () => {
  const data = [
    { region: 'Чуйская', value: 3000, percent: 0.3, color: '#3DAA1B' },
    { region: 'Таласская', value: 5000, percent: 0.5, color: '#1B7A1B' },
    { region: 'Ошская', value: 2000, percent: 0.2, color: '#D6F07C' },
  ];
  const config = {
    data,
    angleField: 'value',
    colorField: 'region',
    color: data.map(d => d.color),
    radius: 1,
    innerRadius: 0.7,
    statistic: {
      title: false as false,
      content: {
        customHtml: () => `<span style='font-size:32px;font-weight:700;'>2024</span>`
      }
    },
    label: {
      type: 'spider',
    //   content: '{percent}',
      style: {
        fontSize: 20,
        fontWeight: 700,
      },
      formatter: (datum: any) => `${Math.round(datum.percent * 100)}%`,
    },
    legend: undefined,
    tooltip: undefined,
  };

  return (
    <>
    <div style={{ display: 'flex', alignItems: 'center', paddingBottom: 50 }}>
        <h1>Обьемы переработки по регионам</h1>
      </div>
    <div style={{ display: 'flex', alignItems: 'center', gap: 48 }}>
      
      <div style={{ width: 280, height: 280, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Pie {...config} />
      </div>
      <div>
        <div style={{ color: '#BFC2D5', fontWeight: 700, fontSize: 20, marginBottom: 16 }}>
          Общий объем - <span style={{ color: '#222', fontWeight: 700 }}>10 000 т</span>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <span style={{ width: 16, height: 16, borderRadius: '50%', background: '#3DAA1B', display: 'inline-block' }} />
            <span style={{ color: '#3DAA1B', fontWeight: 700, fontSize: 18 }}>Чуйская</span>
            <span style={{ color: '#222', fontWeight: 500, fontSize: 18, marginLeft: 8 }}>- 3 000 кг</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <span style={{ width: 16, height: 16, borderRadius: '50%', background: '#1B7A1B', display: 'inline-block' }} />
            <span style={{ color: '#1B7A1B', fontWeight: 700, fontSize: 18 }}>Таласская</span>
            <span style={{ color: '#222', fontWeight: 500, fontSize: 18, marginLeft: 8 }}>- 5 000 кг</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <span style={{ width: 16, height: 16, borderRadius: '50%', background: '#D6F07C', display: 'inline-block' }} />
            <span style={{ color: '#BFCF5C', fontWeight: 700, fontSize: 18 }}>Ошская</span>
            <span style={{ color: '#222', fontWeight: 500, fontSize: 18, marginLeft: 8 }}>- 2 000 кг</span>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};   